// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iAD = 'iAD';
export class IAD extends iBuildInIndicator {
    constructor() {
        super(1);
    }
    get Name() {
        return iAD;
    }
    OnQuote() {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        const close = this.GetPrice(PriceType.Close, 0);
        const high = this.GetPrice(PriceType.High, 0);
        const low = this.GetPrice(PriceType.Low, 0);
        const volume = this.GetVolume(0);
        if (high !== low) {
            this.SetValue(0, 0, ((2 * close - high - low) * volume) / (high - low) + this._GetValue(0, 1));
        }
    }
}
